import SatUnitSelect from "./SatUnitSelect";
import Spinner from "../../shared/UxbiSpinner";
import ProductoFormModal from "../../pages/productos/ProductoFormModal";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal, Form } from "react-bootstrap";
import { Pencil, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import {
  Header,
  Toolbar,
  Status,
  Pager,
  Confirm,
  Field,
  money,
} from "../../shared/UI";
import useResource from "../../shared/useResource";
import { request } from "../../api/http";
import ClienteFormModal from "../../pages/clientes/ClienteFormModal";
const resources = {
    clientes: "clientes",
    productos: "productos",
    unidades: "u-medida",
  },
  labels = {
    clientes: "Clientes",
    productos: "Productos",
    unidades: "Unidades de medida",
  };
export default function CatalogPage() {
  const { kind } = useParams(),
    resource = resources[kind];
  const [search, setSearch] = useState(""),
    [page, setPage] = useState(1),
    [modal, setModal] = useState(null),
    [del, setDel] = useState(null),
    [busy, setBusy] = useState(false);
  const fields =
    kind === "clientes"
      ? ["nombre", "clave", "rfc", "email", "alias_1", "alias_2"]
      : kind === "productos"
        ? ["descripcion", "clave", "alias_1", "alias_2"]
        : ["nombre", "clave"];
  const filters = search
    ? [
        {
          condition: "AND",
          group: fields.map((property) => ({
            property,
            operator: "LIKE",
            value: search,
            condition: "OR",
          })),
        },
      ]
    : [];
  if (kind === "clientes")
    filters.push({ property: "cliente_prospecto", operator: "=", value: 1 });
  const { data, error, loading, reload } = useResource(
    `${resource}?page=${page}&limit=25&filter=${encodeURIComponent(
      JSON.stringify(filters),
    )}`,
  );
  const remove = async () => {
    setBusy(true);
    try {
      await request(`${resource}/${del.id}`, { method: "DELETE" });
      setDel(null);
      reload();
      toast.success("Registro eliminado");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Header
        title={labels[kind]}
        description="Información compartida con tu ERP."
        onNew={() => setModal({})}
      />
      <Toolbar
        search={search}
        onSearch={(v) => {
          setSearch(v);
          setPage(1);
        }}
        onReload={reload}
        loading={loading}
      />
      <Status loading={loading} error={error} onRetry={reload} />
      {!loading && !error && (
        <div className="record-list">
          {(data?.data || []).map((r) => (
            <article className="record" key={r.id}>
              <div>
                <small>{r.clave || `#${r.id}`}</small>
                <h3>{r.nombre || r.descripcion}</h3>
                <p>
                  {kind === "unidades"
                    ? r.clave_unidad_medida_sat
                      ? `Clave SAT: ${r.clave_unidad_medida_sat}`
                      : "—"
                    : r.email || r.alias_1 || r.rfc || "—"}
                </p>
              </div>
              {kind === "productos" && (
                <div className="record-facts">
                  <strong>{money(r.precio)}</strong>
                  <span>
                    {r.unidad_medida?.nombre || r.unidad_medida?.clave}
                  </span>
                </div>
              )}
              <div className="record-actions">
                <Button
                  size="sm"
                  variant="light"
                  title="Editar"
                  onClick={() => setModal(r)}
                >
                  <Pencil size={17} />
                </Button>
                <Button
                  size="sm"
                  variant="light"
                  title="Eliminar"
                  onClick={() => setDel(r)}
                >
                  <Trash2 size={17} />
                </Button>
              </div>
            </article>
          ))}
          {!data?.data?.length && (
            <div className="empty">No hay registros con estos filtros.</div>
          )}
        </div>
      )}
      <Pager data={data} page={page} setPage={setPage} />
      {modal &&
        (kind === "clientes" ? (
          <ClienteFormModal
            show
            clienteId={modal.id}
            onHide={() => setModal(null)}
            onSaved={() => {
              setModal(null);
              reload();
            }}
          />
        ) : kind === "productos" ? (
          <ProductoFormModal
            show
            productId={modal.id}
            onHide={() => setModal(null)}
            onSaved={() => {
              setModal(null);
              reload();
            }}
          />
        ) : (
          <BasicForm
            kind={kind}
            record={modal}
            onClose={() => setModal(null)}
            onSaved={() => {
              setModal(null);
              reload();
            }}
          />
        ))}
      {del && (
        <Confirm
          title="Eliminar registro"
          busy={busy}
          onClose={() => setDel(null)}
          onConfirm={remove}
        >
          El ERP comprobará las relaciones antes de eliminar el registro.
        </Confirm>
      )}
    </>
  );
}
function BasicForm({ record, onClose, onSaved }) {
  const [form, setForm] = useState(record),
    [busy, setBusy] = useState(false);
  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await request(`u-medida${record.id ? "/" + record.id : ""}`, {
        method: record.id ? "PUT" : "POST",
        body: {
          clave: form.clave,
          nombre: form.nombre,
          clave_unidad_medida_sat: form.clave_unidad_medida_sat,
          unidad_medida_sat: form.unidad_medida_sat,
        },
      });
      toast.success("Cambios guardados");
      onSaved();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal show onHide={busy ? undefined : onClose} centered>
      <Form onSubmit={save}>
        <Modal.Header closeButton={!busy}>
          <Modal.Title>
            {record.id ? "Editar" : "Crear"} unidad de medida
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Field
            label="Clave"
            value={form.clave}
            onChange={(v) => setForm((f) => ({ ...f, clave: v }))}
            required
            maxLength={5}
          />
          <Field
            label="Nombre"
            value={form.nombre}
            onChange={(v) => setForm((f) => ({ ...f, nombre: v }))}
            required
            maxLength={45}
          />
          <SatUnitSelect
            value={form.clave_unidad_medida_sat}
            description={form.unidad_medida_sat}
            disabled={busy}
            onChange={(clave, nombre) =>
              setForm((f) => ({
                ...f,
                clave_unidad_medida_sat: clave,
                unidad_medida_sat: nombre,
              }))
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" disabled={busy} onClick={onClose}>
            Volver
          </Button>
          <Button type="submit" disabled={busy}>
            {busy ? <Spinner size="sm" /> : "Guardar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
